<template>
  <div>
    <button type="button" @click="show = true">
      <InformationCircleIcon class="w-4 h-4" />
    </button>
    <Modal @close="show = false" :outsideClickable="true" v-if="show">
      <div v-text="tip" class="whitespace-pre-wrap text-center"></div>
    </Modal>
  </div>
</template>

<script>
import Modal from "../modal/Modal.vue";
import { InformationCircleIcon } from "@vue-hero-icons/outline";
export default {
  components: {
    InformationCircleIcon,
    Modal,
  },
  props: {
    tip: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
